// extracted by mini-css-extract-plugin
export default {"p2":"eCBnZPLoxbNAj6_7f4mI","loader":"rP7h75FT1MDKIEmP3lUv","container":"_ZgftMlGVcv9ArwDH0bn","bounce":"_wyMl74FXl0kLVjaoFQg"};